import type { Processor } from "unified";
import type { VFile } from "vfile";

import { preprocessMarkdownForGfmParse } from "@/lib/prepare-markdown-mixed-tables";

/**
 * Wraps the processor `parse` so markdown is normalized before remark-parse /
 * micromark run (same pipeline as `prepareMarkdownForAsciiGrids` minus ASCII fencing).
 */
export function remarkPreprocessBrokenGfmTables(this: Processor) {
  const parse = this.parse.bind(this);
  this.parse = (file: VFile) => {
    if (typeof file.value === "string") {
      file.value = preprocessMarkdownForGfmParse(file.value);
    }
    return parse(file);
  };
}
